<template>
  <div>
    <!--Rows-->
    <SectionTitle
      icon="fas fa-user-edit"
      content="Participantes"
      container-class="mt-4 mb-2"
      reverse
    />
    <div v-for="(item, index) in model" :key="index">
      <participant
        v-model="item.model"
        @send-email="sendEmail"
        @update="updateEmail(item.model)"
        @copy="getLink"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}
.bg-yellow {
  background-color: $yellow;
}
.bg-orange {
  background-color: #f3ae81;
}
</style>

<script>
import ActionButton from "ActionButton";
import CustomInput from "CustomInput";
import SectionTitle from "SectionTitle";
import signatures from "@/services/signatures";
import alert from "@/mixin/alert.mixin";
import Participant from "./Participant.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { SignatureStatus } from "@/utils/constants/signature/signatureStatus";

export default {
  name: "Tab10ListOfParticipant",
  components: {
    ActionButton,
    SectionTitle,
    CustomInput,
    ValidationProvider,
    ValidationObserver,
    Participant
  },
  mixins: [alert],
  props: {
    listOfPaticipants: {
      type: Array,
      default: () => []
    },
    listOfSignatures: {
      type: Array,
      default: () => []
    },
    documentId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    async sendEmail(item) {
      const { email, username } = item;
      if (email && username) {
        const { data } = await signatures
          .sendEmail(email, username.trim(), this.documentId)
          .catch(err => {
            if (err && err.response && err.response.data) {
              this.ShowToast("Error", err.response.data.message, "error");
            } else {
              this.ShowToast("Error", err.message, "error");
            }
          });
        if (data) {
          this.ShowToast(
            "Proceso exitoso",
            "Se envió el correo electrónico exitosamente.",
            "success"
          );
        }
      }
    },
    async updateEmail(item) {
      const { email, userId } = item;
      if (email && userId) {
        const { data } = await signatures
          .updateEmail(this.documentId, userId, email)
          .catch(err => {
            if (err && err.response && err.response.data) {
              this.ShowToast("Error", err.response.data.message, "error");
            } else {
              this.ShowToast("Error", err.message, "error");
            }
          });
        if (data) {
          this.ShowToast(
            "Proceso exitoso",
            "El correo electrónico se actualizó exitosamente.",
            "success"
          );
          this.$emit("reload");
        }
      }
    },
    async getLink() {
      if (this.documentId) {
        const { data } = await signatures
          .getLinkDigitalSignture(this.documentId)
          .catch(err => {
            if (err && err.response && err.response.data) {
              this.ShowToast("Error", err.response.data.message, "error");
            } else {
              this.ShowToast("Error", err.message, "error");
            }
          });
        if (data) {
          navigator.clipboard.writeText(data);
          this.ShowToast(
            "Proceso exitoso",
            "Se copió el enlace exitosamente en su ordenador.",
            "success"
          );
        }
      }
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    showTypeError() {
      return model => {
        const types = this.listOfSignatures.map(e => e.model.type);
        const justOne = types.some(s => s && s.id == SignatureTypes.email);
        if (model.type && justOne) {
          return model?.type?.id != SignatureTypes.email;
        }
        return justOne;
      };
    },
    StatusName() {
      return statusId => {
        if (statusId === SignatureStatus.Signed) return "Firmado";
        return "No firmado";
      };
    },
    StatusColor() {
      return statusId => {
        if (statusId === SignatureStatus.Signed) return "bg-orange";
        return "bg-yellow";
      };
    },
    ShowOptions() {
      return statusId => {
        return statusId === SignatureStatus.UnSigned;
      };
    },
    model: {
      get() {
        if (!Array.isArray(this.listOfPaticipants)) {
          return [];
        }

        return this.listOfPaticipants.map(e => {
          return {
            model: e
          };
        });
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
